import { RootState } from '../../../app/store';
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"
import ContactNameModel from '../models/ContactNameModel';

interface contactSelectorState {
    searchResults: ContactNameModel[],
}

const initialState: contactSelectorState = {
    searchResults: [],
}

export const ContactSelectorSlice = createSlice({
    name: "ContactSelector",
    initialState,
    reducers: {
        setContactSearchResults: (state, action: PayloadAction<ContactNameModel[]>) => {
            state.searchResults = action.payload;
        },
    }
});

export const contactSelectorSelector = createSelector(
    (state: RootState) => state.contactSelectorSelector,
    (data) => data
);

export const {
    setContactSearchResults,
} = ContactSelectorSlice.actions;

export default ContactSelectorSlice.reducer;